import ShimmerPlaceholder, { createShimmerPlaceholder } from "./Shimmer";
import SquareShimmer from "./SquareShimmer";

export {
    ShimmerPlaceholder as default,
    createShimmerPlaceholder,
    SquareShimmer,
};
